const getInitialState = () => ({
    openRequests: [],
    failedRequests: [],
    updatedAt: 0,
    employeeRoles: {
        entries: {},
        maxCount: 0,
    },
    lastInteractiveId: null,
});

export default {
    getInitialState
};
